<span [matTooltip]="data.fileName" *ngIf="!params.node.group">
  {{ data.file }}
</span>
<ng-container *ngIf="params.node.group">
  {{ params.node.aggData.file }}
</ng-container>
